import React from 'react';

type JourneyInputVariant = 'default' | 'money';

export interface JourneyTextInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
  variant?: JourneyInputVariant;
}

function cx(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(' ');
}

export const JourneyTextInput: React.FC<JourneyTextInputProps> = ({
  className,
  hasError = false,
  variant = 'default',
  ...props
}) => {
  const variantClassName =
    variant === 'money'
      ? cx('money-form-field__control', 'money-form-field__control--input')
      : '';

  return (
    <input
      {...props}
      className={cx(
        variantClassName,
        variant === 'money' && hasError && 'is-error',
        className,
      )}
    />
  );
};

export const TextInput = JourneyTextInput;

export default JourneyTextInput;
